import React, { useCallback, useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import AiSpendSummary from "../../components/ai/AiSpendSummary";
import AiUsageTable from "../../components/ai/AiUsageTable";
import AiCapChange from "../../components/ai/AiCapChange";

// Founder Settings → AI usage & limits. Platform-wide monthly cap on the Emergent Universal Key.
export default function AiUsageLimits() {
  const [u, setU] = useState(null);
  const [status, setStatus] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/ai/usage").then((r) => setU(r.data))
    .catch((e) => setErr(e?.response?.data?.detail?.message || "Could not load AI usage.")), []);
  useEffect(() => { load(); api.get("/mfa/status").then((r) => setStatus(r.data)).catch(() => {}); }, [load]);
  return (
    <AppShell title="AI usage & limits" subtitle="Month-to-date AI spending by feature, against the monthly limit">
      <div className="mx-auto w-full max-w-[1000px] px-4 md:px-6 space-y-4" data-testid="ai-usage-page">
        {err && <p role="alert" className="text-sm text-red-700" data-testid="ai-usage-error">{err}</p>}
        {!u && !err && <p className="font-mono text-xs" data-testid="ai-usage-loading">Loading…</p>}
        {u && <AiSpendSummary u={u} />}
        {u && <AiUsageTable rows={u.by_feature} />}
        {u && <AiCapChange key={u.cap_usd} cap={u.cap_usd} status={status} onSaved={load} />}
      </div>
    </AppShell>
  );
}
